import { useToastStore } from "./toastStore";
import type { ToastVariant } from "./toastStore";

type ToastOptions = {
  message?: string;
  duration?: number;
};

function push(variant: ToastVariant, title: string, opts: ToastOptions = {}) {
  return useToastStore.getState().add({
    variant,
    title,
    message: opts.message,
    duration: opts.duration ?? 5000,
  });
}

/**
 * Imperative toast helper — safe to call from outside React components
 * (event handlers, service functions, etc.).
 *
 * Usage:
 *   import { toast } from "@/components/Toast/useToast";
 *   toast.error("Invalid credentials");
 *   toast.success("Profile saved", { message: "Your changes are live." });
 */
export const toast = {
  error: (title: string, opts?: ToastOptions) => push("error", title, opts),
  success: (title: string, opts?: ToastOptions) => push("success", title, opts),
  info: (title: string, opts?: ToastOptions) => push("info", title, opts),
};

/**
 * Hook version — same API but returned from a hook if you prefer it.
 */
export function useToast() {
  return toast;
}
